import { Tooltip } from "@mui/material";
import _ from "lodash";
import { memo, useEffect } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import { Controller, useFormContext } from "react-hook-form";
import HTMLInput from "../../_Components/HTMLInput";
import SelectComponent from "../../_Components/ReactSelectComponent";
import SplitNumber from "../../_Components/SplitNumber";
import AddCircleRounded from "@mui/icons-material/AddCircleOutlineRounded";


const ReserveItemGroup = ({
  nameDate,
  group,
  service,
  reserveDescriptions,
  reserveDetailGroup,
  openModalAddDescription,
  reserveItems,
  reserveDetailJson,
  formatTime
}) => {
  const { setValue, watch, control } = useFormContext()

  useEffect(() => {
    setValue(`${nameDate}-${service}-${group.id}-Des`, _.find(reserveDescriptions, function (obj) {
      return _.toString(obj.value) == reserveDetailGroup?.gDesId;
    }) ?? null)

    setValue(`${nameDate}-${service}-Des`, _.find(reserveDescriptions, function (obj) {
      return _.toString(obj.value) == reserveDetailJson?.dDesId;
    }) ?? null)

    setValue(`${nameDate}-${service}-IA`, reserveDetailJson && reserveDetailJson.dIA != null ? reserveDetailJson.dIA : false)
  }, [reserveDetailJson, reserveDetailGroup])

  return (
    <div className="bg-white rounded-3 p-2 my-3" style={{ border: "1px solid #ddd " }}>
      <div className=" pb-2" style={{ borderBottom: "1px solid #ddd " }}>
        <Row className="justify-content-md-right position-relative">
          <Col sx="12" sm="7" className="my-auto">
            <Controller
              control={control}
              defaultValue={reserveDetailGroup?.gID != null ? reserveDetailGroup.gID : false}
              key={JSON.stringify(reserveDetailGroup ?? {}) + service?.toString() + `${nameDate}-${group.id}-ID`}
              name={`${nameDate}-${service}-${group.id}-ID`}
              render={({ field }) => <input
                type="checkbox"
                style={{ margin: "0 5px" }}
                title="نمایش/عدم نمایش"
                checked={field.value}
                {...field}
              />}
            />

            <Controller
              control={control}
              defaultValue={reserveDetailGroup?.gIA != null ? reserveDetailGroup.gIA : false}
              key={JSON.stringify(reserveDetailGroup ?? {}) + service?.toString() + `${nameDate}-${group.id}-IA`}
              name={`${nameDate}-${service}-${group.id}-IA`}
              render={({ field }) => <input
                type="checkbox"
                style={{ margin: "0 5px" }}
                title="فعال/غیرفعال"
                checked={field.value}
                {...field}
              />}
            />
            <span className="fw-bold"> {group.title}</span>
          </Col>
          <Col xs="10" sm="5" className="mt-2 mt-md-0 pr-2 d-flex align-items-center">
            <Controller
              name={`${nameDate}-${service}-${group.id}-Des`}
              control={control}
              render={({ field }) => (
                <SelectComponent
                  className="w-100"
                  variant="outlined"
                  size="small"
                  noLabel
                  placeholder="توضیحات گروه"
                  onChange={field.onChange}
                  value={field.value}
                  options={reserveDescriptions.map(item => ({ ...item, label: item.label.length > 40 ? item.label.slice(0, 40) + "…" : item.label }))}
                />
              )}
            />
            <Button
              onClick={() => openModalAddDescription(nameDate, group.id)}
              variant="light h-100 mx-1"
            >
              <AddCircleRounded
                fontSize="large"
                className="big-icon"
              />
            </Button>

          </Col>
          {/* <Col xs="2" sm="auto" className="my-auto px-0"></Col> */}
        </Row>
      </div>
      <div style={{ display: "flex", flexDirection: "column" }}>
        {reserveItems.map(function (item, index) {
          let reserveDetailItem =
            !_.isNil(reserveDetailGroup) && _.isArray(reserveDetailGroup.i)
              ? _.find(reserveDetailGroup.i, { iId: item.id })
              : "";

          const dayCapacity = watch(
            `${nameDate}-${service}-${group.id}-${item.id}-C`,
            reserveDetailItem?.iC ? reserveDetailItem.iC : item.defaultReserveCountPerDay,
          ); //بررسی لحظه ای ظرفیت روزانه
          const fullCapacity = watch(
            `${nameDate}-${service}-${group.id}-${item.id}-IFC`,
            reserveDetailItem?.iIFC != null ? reserveDetailItem.iIFC : item.isFullCapacity,
          ); //بررسی لحظه ای ظرفیت تکمیل

          if (!_.isUndefined(item) && !_.isEmpty(item))
            return (
              <Row
                key={index}
                className="align-items-center position-relative"
                style={{ margin: "10px 0 15px 0" }}
              >
                <Col xs="12" sm className="px-0 d-flex align-items-center mb-3 mb-sm-0">
                  <Controller
                    defaultValue={reserveDetailItem?.iID != null ? reserveDetailItem.iID : false}
                    key={JSON.stringify(reserveDetailGroup ?? {}) + service + `${nameDate}-${group.id}-${item.id}-ID`}
                    name={`${nameDate}-${service}-${group.id}-${item.id}-ID`}
                    control={control}
                    render={({ field }) => <input
                      type="checkbox"
                      style={{ margin: "0 5px" }}
                      title="نمایش/عدم نمایش"
                      checked={field.value}
                      {...field}
                    />}
                  />
                  <Controller
                    defaultValue={reserveDetailItem?.iIA != null ? reserveDetailItem.iIA : false}
                    key={JSON.stringify(reserveDetailGroup ?? {}) + service + `${nameDate}-${group.id}-${item.id}-IA`}
                    control={control}
                    name={`${nameDate}-${service}-${group.id}-${item.id}-IA`}
                    render={({ field }) => <input
                      type="checkbox"
                      style={{ margin: "0 5px" }}
                      title="فعال/غیرفعال"
                      checked={field.value}
                      {...field}
                    />}
                  />
                  <span>{item.title}</span>
                </Col>
                <Col xs="auto" className="px-0 mb-2 mb-sm-0 position-relative">
                  <Controller
                    defaultValue={reserveDetailItem?.iMinC
                      ? reserveDetailItem.iMinC
                      : item.minimumReserveCountPerDay
                    }
                    key={JSON.stringify(reserveDetailGroup ?? {}) + service + `${nameDate}-${group.id}-${item.id}-MinC`}
                    control={control}
                    name={`${nameDate}-${service}-${group.id}-${item.id}-MinC`}
                    render={({ field }) => <HTMLInput
                      hiddenClear={true}
                      value={field.value ?? ""}
                      onInput={(e) => {
                        // فقط اعداد مثبت و صفر مجاز باشه
                        e.target.value = e.target.value.replace(/[^0-9]/g, "");
                        field.onChange(e)
                      }}
                      margin="normal"
                      variant="outlined"
                      size="small"
                      className="form-control text-center englishInput"
                      title="حداقل تعداد"
                      style={{
                        margin: "0 auto",
                        width: "60px",
                        height: "2.8rem",
                        padding: "0",
                      }}
                      type="number"
                      inputMode="numeric"
                    />}
                  />

                </Col>
                <Col xs="auto" className="px-0 mb-2 mb-sm-0 mx-3 position-relative">
                  <Controller
                    control={control}
                    defaultValue={reserveDetailItem?.iC ? reserveDetailItem.iC : item.defaultReserveCountPerDay}
                    key={JSON.stringify(reserveDetailGroup ?? {}) + service + `${nameDate}-${group.id}-${item.id}-C`}
                    name={`${nameDate}-${service}-${group.id}-${item.id}-C`}
                    render={({ field }) => <HTMLInput
                      hiddenClear={true}
                      value={field.value ?? ""}
                      onInput={(e) => {
                        // فقط اعداد مثبت و صفر مجاز باشه
                        e.target.value = e.target.value.replace(/[^0-9]/g, "");
                        field.onChange(e)
                      }}
                      margin="normal"
                      variant="outlined"
                      size="small"
                      className="form-control text-center englishInput"
                      title="ظرفیت روزانه"
                      style={{
                        margin: "0 auto",
                        width: "60px",
                        height: "2.8rem",
                        padding: "0",
                      }}
                      type="number"
                      inputMode="numeric"
                    />}
                  />
                </Col>
                {/* <Col xs="auto" className="px-0 mb-2 mb-sm-0 position-relative">
                  <Controller
                    defaultValue={
                      reserveDetailItem && reserveDetailItem.iIDL != null
                        ? reserveDetailItem.iIDL
                        : false
                    }
                    control={control}
                    name={`${nameDate}-${group.id}-${item.id}-IDL`}
                    render={({ field }) => <input
                      type="checkbox"
                      style={{ margin: "0 5px" }}
                      title="محدودیت روزانه اعمال شود؟"
                      checked={field.value}
                      {...field}
                    />}
                  />
                </Col> */}
                <Col xs="auto" className="px-0 mb-2 mb-sm-0 position-relative">
                  <Controller
                    defaultValue={
                      reserveDetailItem?.iIFC != null ? reserveDetailItem.iIFC : item.isFullCapacity
                    }
                    key={JSON.stringify(reserveDetailGroup ?? {}) + service + `${nameDate}-${group.id}-${item.id}-iIFC`}
                    name={`${nameDate}-${service}-${group.id}-${item.id}-IFC`}
                    control={control}
                    render={({ field }) => <input
                      type="checkbox"
                      style={{ margin: "0 5px" }}
                      title="ظرفیت تکمیل"
                      checked={field.value}
                      {...field}
                    />}
                  />
                </Col>
                <Col xs="auto" className="px-0 mb-2 mb-sm-0 min-width-price">
                  <label style={{ margin: "0 5px" }} className="text-decoration-line-through ">
                    <SplitNumber number={item.originalPrice} />
                  </label>
                  <label style={{ margin: "0 5px" }} className="">
                    <SplitNumber number={item.price} />
                  </label>
                </Col>
                <Col xs="auto" sm="auto" className="px-0 mb-2 mb-sm-0">
                  <label style={{ margin: "0 5px" }} className="text-primary">
                    {formatTime(item.reservationExpirationTime)}
                  </label>
                </Col>
                <Col xs="auto" sm="auto" className="px-0 text-center mb-2 mb-sm-0">
                  <span style={{ width: "32px", display: "inline-block" }}>
                    {!_.isEmpty(item.reservationByPhone) && (
                      <Tooltip title={item.reservationByPhone} arrow placement="top">
                        <i className="fa fa-phone text-primary"></i>
                      </Tooltip>
                    )}

                    {((_.isEmpty(item.reservationByPhone) &&
                      (_.isEmpty(_.trim(dayCapacity)) || _.parseInt(dayCapacity) == 0) &&
                      dayCapacity !== undefined) ||
                      fullCapacity) && (
                        <Tooltip title="آیتم قابل رزرو نمی باشد" arrow placement="top">
                          <i className="fa fa-eye-slash text-danger fs-normal flipX"></i>
                        </Tooltip>
                      )}
                  </span>
                </Col>
              </Row>
            );
        })}
      </div>
    </div>
  )
}

export default memo(ReserveItemGroup)